import type { SVGProps } from "react";
export default function SvgFileFull(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 16 16"
			{...props}
		>
			<path
				fill="#737373"
				stroke="#737373"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1.5}
				d="M11.333 14H4.667a1.334 1.334 0 0 1-1.334-1.333V3.333A1.333 1.333 0 0 1 4.667 2h4.666l3.334 3.333v7.334A1.334 1.334 0 0 1 11.333 14"
			/>
			<path
				stroke="#737373"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1.5}
				d="M9.333 2v2.667a.667.667 0 0 0 .667.666h2.667"
			/>
			<path
				stroke="white"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1.5}
				d="M6 6h.667"
			/>
			<path
				stroke="white"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1.5}
				d="M6 8.667h4"
			/>
			<path
				stroke="white"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1.5}
				d="M6 11.333h4"
			/>
		</svg>
	);
}
